import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PostInspectionDiyAuctionStart from "./component";
import { getUpdatedDiyDetails, setCurrentGaEventDetails, stopAuction, updateImpressions } from "../post-inspection-diy/actions";

const mapStateToProps = ({
    postInspectionDiy: {
        inspectionResponse
    }
}) => ({
    inspectionResponse
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setCurrentGaEventDetailsConnect: setCurrentGaEventDetails,
    getUpdatedDiyDetailsConnect: getUpdatedDiyDetails,
    updateImpressionsConnect: updateImpressions,
    stopAuctionConnect: stopAuction
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PostInspectionDiyAuctionStart);
